const ApiStore = require("stores/abstract/ApiStore");
const env = require("services/env");
const router = require("services/router");

module.exports = new ApiStore(
	env.get("stores.teachers.collection", []),
	env.get("stores.teachers.constraints", {}),
	env.get("stores.teachers.metadata", {}),
	{endpoint: router.route("api.teachers.index")}
);



// WEBPACK FOOTER //
// ./resources/js/stores/TeachersStore.js